import GreyLoadingOverlay from '@/components/loading/GreyLoadingOverlay';
import { Button } from '@mui/material';
import { useRouter } from 'next/router';
import React from 'react';
import { PATH_NAME } from '../../../../configs/pathName';
import { QuickLoginModalHOC } from '../../../modal/LoginModal2HOC';
import { OutlinedCheck } from '../../svgIcon/outlined';

export enum EBusinessGroupButtonMode {
  Joined = 'Joined',
  Revoked = 'Revoked',
  Requested = 'Requested',
}

interface IBusinessGroupButton {
  handleLogicAccessGroup: Function;
  groupId: string;
  mode: EBusinessGroupButtonMode;
  isLoading?: boolean;
}

const BusinessJoinGroupButton = ({
  handleLogicAccessGroup,
  groupId,
  mode,
  isLoading,
}: IBusinessGroupButton) => {
  const router = useRouter();

  const renderMode = (
    mode: EBusinessGroupButtonMode
  ): {
    label: string;
    icon: React.ReactElement;
    className: React.HTMLAttributes<unknown>['className'];
  } => {
    switch (mode) {
      case EBusinessGroupButtonMode.Requested:
        return {
          label: 'Đã gửi yêu cầu',
          icon: <OutlinedCheck fontSize={14} />,
          className:
            '!border !border-solid !border-Primary/Border !bg-[#B1E7FF4D] !text-Primary/Main hover:!bg-[#009FE499] hover:!text-Text/Darkbackground/Primary',
        };
      case EBusinessGroupButtonMode.Revoked:
        return {
          label: 'Tham gia',
          icon: <div className="h-6 w-0"></div>,
          className:
            '!bg-Primary/Main !text-Text/Darkbackground/Primary hover:!bg-Primary/Hover',
        };
      default:
        return {
          label: 'Đã tham gia',
          icon: <OutlinedCheck fontSize={14} />,
          className:
            '!bg-Action/DisabledBackground !border !border-solid !border-Other/Outlinedborder-stroke !text-Text/Lightbackground/Disabled',
        };
    }
  };

  const buttonInfo = renderMode(mode);

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className={`relative overflow-hidden rounded-md ${
        mode === EBusinessGroupButtonMode.Joined && 'cursor-default'
      }`}
    >
      <GreyLoadingOverlay show={isLoading} size={25} />
      <QuickLoginModalHOC
        handleClickWhenDisabledQuickLogin={
          mode === EBusinessGroupButtonMode.Joined
            ? () => {}
            : handleLogicAccessGroup
        }
        loginSuccessCb={() => {
          // add param to auto join fo user
          mode === EBusinessGroupButtonMode.Joined
            ? () => {}
            : handleLogicAccessGroup();
          router.push({
            pathname: PATH_NAME.MY_GROUPS_DETAIL,
            query: {
              gid: groupId,
            },
          });
        }}
      >
        <Button
          disabled={mode === EBusinessGroupButtonMode.Joined}
          className={`!h-full !w-full !rounded-md !border !py-[8px] !text-center !normal-case ${buttonInfo.className} flex gap-x-2 !text-sm !font-semibold !leading-4`}
        >
          {buttonInfo.icon}
          {buttonInfo.label}
        </Button>
      </QuickLoginModalHOC>
    </div>
  );
};

export default BusinessJoinGroupButton;
